import Vue from 'vue';

export default {
    SET_DRIVERS: (state, checkDrivers) => {
        state.checkDrivers = checkDrivers;
    },

    SET_PHOTO_REPORTS: (state, photoReports) => {
        state.activePhotoReports = photoReports;
    },

    SET_PHOTO_REPORT: (state, photoReport) => {
        state.photoReport = photoReport;
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination;
    },

    SET_PAGINATION_ACTIVE: (state, pagination) => {
        state.paginationActive = pagination;
    },

    SET_FINISHED_PHOTO_REPORTS: (state, photoReports) => {
        state.finishedPhotoReports = photoReports;
    },

    SET_PAGINATION_FINISHED: (state, pagination) => {
        state.paginationFinished = pagination;
    },

    REMOVE_PHOTO_REPORT: (state, photoReportId) => {
        const index = state.activePhotoReports.findIndex(it => photoReportId == it.id);
        state.activePhotoReports.splice(index, 1);
    },

    SET_IMAGES: (state, images) => {
        state.images = images;
    },

    REMOVE_IMAGE: (state, image) => {
        const index = state.images.findIndex(it => it.id === image.id);
        state.images.splice(index, 1);
    },

    SET_DRIVER_STATUS: (state, payload) => {
        const index = state.photoReport.items.findIndex(it => it.driverId === payload.driverId);
        Vue.set(state.photoReport.items[index], 'status', payload.status);
    },

    SET_REQUEST: (state, payload) => {
        const index = state.activePhotoReports.findIndex(it => it.id == payload.id);
        Vue.set(state.activePhotoReports[index], 'requestName', payload.name);
        Vue.set(state.activePhotoReports[index], 'reasonName', payload.reason.name);
        Vue.set(state.activePhotoReports[index], 'reasonId', payload.reason.id);
        Vue.set(state.activePhotoReports[index], 'allDrivers',
            +payload.success + +state.activePhotoReports[index].allDrivers || state.photoReport.items[index].allDrivers
        );
    }
};
